import { render, staticRenderFns } from "./chevron-icon.vue?vue&type=template&id=56984cca"
import script from "./chevron-icon.vue?vue&type=script&lang=js"
export * from "./chevron-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports